export enum FILE_STATUSES {
  PENDING = 0,
  LOADING = 1,
  DONE = 2,
  FAILED = 3,
}
